import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class TextosService{
    constructor(){}

    async consultarTextos(codigoRamo: number){
        let url=new URL(`${environment.backendUrl}/api/textos`);
        let parameters={
            cod_ramo: codigoRamo==null?0:codigoRamo
        }
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
        return await (await fetch(url.toString(), {method: "GET"})).json();
    }
}